import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './Landing';
import Scanner from './Scanner';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import DoNotSell from './DoNotSell';
import Contact from './Contact';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/scan" element={<Scanner />} />
        <Route path="/payment-success" element={<Scanner />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/do-not-sell" element={<DoNotSell />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {/* <CookieBanner /> */}
    </Router>
  );
}

export default App;